import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from './components/ui/toaster';
import LandingPage from './components/LandingPage';
import { LoginPage, RegisterPage } from './components/AuthPages';
import ForgotPassword from './components/ForgotPassword';
import LanguageSelection from './components/LanguageSelection';
import Dashboard from './components/Dashboard';
import LearningInterface from './components/LearningInterface';
import Translator from './components/Translator';
import AdminLogin from './components/AdminLogin';
import AdminDashboard from './components/AdminDashboard';
import ProgramDashboard from './components/program/ProgramDashboard';
import DayOverview from './components/program/DayOverview';
import DayLesson from './components/program/DayLesson';
import DayTest from './components/program/DayTest';
import FinalTest from './components/program/FinalTest';
import ChangePassword from './components/ChangePassword';
import { initializeAdMob, showBannerAd } from './services/admob';

function App() {
  useEffect(() => {
    // Detect native Capacitor app and add padding for status bar + ad banner
    const isNative = window.Capacitor?.isNativePlatform?.() || false;
    if (isNative) {
      document.body.classList.add('native-app');
    }

    const setupAdMob = async () => {
      const initialized = await initializeAdMob();
      if (initialized) {
        await showBannerAd();
      }
    };
    setupAdMob();
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          
          {/* User Routes */}
          <Route path="/language-selection" element={<LanguageSelection />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/learn/:category" element={<LearningInterface />} />
          <Route path="/translator" element={<Translator />} />
          <Route path="/change-password" element={<ChangePassword />} />
          
          {/* 15-Day Program Routes */}
          <Route path="/program" element={<ProgramDashboard />} />
          <Route path="/program/:language" element={<DayOverview />} />
          <Route path="/program/:language/day/:dayNumber" element={<DayLesson />} />
          <Route path="/program/:language/day/:dayNumber/test" element={<DayTest />} />
          <Route path="/program/:language/final-test" element={<FinalTest />} />
          
          {/* Admin Routes */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/change-password" element={<ChangePassword />} />
          
          {/* Fallback */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
